export default "__VITE_ASSET__CdgSm40l__"